import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DataEntryStep1 } from '../../models/data-entry-step1'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { PortalGlobals } from '../../../portalglobals'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { ValidAgent } from '../../models/valid-agent'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import * as moment from 'moment'
import { AuthService } from '../../../auth/auth-service'
@Component({
    selector: 'DataEntryStep1',
    templateUrl: 'data-entry-step1.html'
})
export class DataEntryStep1Component implements OnInit {
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    dataEntryStep1 = {} as DataEntryStep1
    isValidAgent: boolean
    isFormValid: boolean
    selFaxContactType: string
    //dateofReceiptInvalid: boolean
    //ContactTypeInvalid: boolean
    showMLPAP: boolean
    public optionrbConactType: ValidatedRadioButtonModel[] = []
    optionrbEnrollmentMethod: ValidatedRadioButtonModel[] = []
    optionrbScope: ValidatedRadioButtonModel[] = []
    selEnrollmentMethod: string
    ErrorMessages: any[]
    enrollment: EnrollmentViewModel = {} as EnrollmentViewModel
    agentUserName: string
    hasError: boolean
    EnrollmentMethodError: boolean
    SOAError: boolean
    validAgentModel: ValidAgent
    CUID: string
    AgentID: string
    AdminID: number
    errorMessage: any[]
    IsErrorMesssage: boolean = false
    public loading: boolean = false
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    currentDate: Date
    isAEPTest: boolean

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        private _authService: AuthService,
        public _global: PortalGlobals
    ) {
        this.optionrbConactType.push({ value: 'Mail', htmlLabel: 'Mail' }, { value: 'Fax', htmlLabel: 'Fax' })
        this.optionrbEnrollmentMethod.push(
            { value: 'Mail', htmlLabel: 'I received a paper application in the mail' },
            { value: 'Paper', htmlLabel: 'I completed a paper application in a face to face meeting with the beneficiary' }
        )
        this.optionrbScope.push(
            { value: 'ScopeIncluded', htmlLabel: 'A Scope of Appointment is included with this enrollment form' },
            {
                value: 'ScopeNotIncluded',
                htmlLabel:
                    'Scope of Appointment was NOT completed because the agent did not have an individual or one-on-one marketing appointment (whether in person, telephonically or otherwise) with the applicant.'
            }
        )
        //this.dateofReceiptInvalid = false
        this.errorMessage = []
        this.GetCurrentDate()
    }

    ngOnInit() {
        let isExternalAgent: boolean = false
        //Check if external agent

        this.enrollment = this._enrollementGateway.getEnrollmentViewModel()
        isExternalAgent = this.enrollment.ISEXTERNALAGENT

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        this._authService.isAuthorization('data-entry')

        if (this._global.currentUser.userProfileName !== undefined && !this._global.currentUser.IsEnoller) {
            this.agentUserName = this._global.currentUser.userProfileName
        } else {
            this.agentUserName = ''
        }

        if (!this.enrollment.ISBACK) {
            this.enrollment = {} as EnrollmentViewModel
            //Remove session object
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                sessionStorage.removeItem('EnrollmentCache')
            }
        } else {
            this.dataEntryStep1.DateofReceipt = this.enrollment.DATEOFRECEIPT
            this.dataEntryStep1.DataSource = this.enrollment.AGENTDEX
            this.selFaxContactType = this.enrollment.AGENTDEX
            this.selEnrollmentMethod = this.enrollment.AGENTDEX
            this.dataEntryStep1.SOA = this.enrollment.SOA
            this.agentUserName = this.enrollment.AGENTNAME
        }

        this.dataEntryStep1.AgentName = this.agentUserName
        // this._enrollementGateway.setEnrollmentViewModel(this.enrollment)

        this.enrollment.FORMNAME = 'DATAENTRY'
        this.enrollment.ISEXTERNALAGENT = isExternalAgent
        this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
        this.showMLPAP = false
        this.isValidAgent = false
        this.hasError = false
        this.ErrorMessages = [] as any[]
        this.EnrollmentMethodError = false
        this.SOAError = false

        if (User !== undefined) {
            if (this._global.currentUser.IsDataEntrySpecialist || this._global.currentUser.IsDataEntryGroupSpecialist) {
                this.onContinue()
            }
        } else {
            if (this._global.currentUser.IsDataEntrySpecialist || this._global.currentUser.IsDataEntryGroupSpecialist) {
                this.onContinue()
            }
        }

        this._enrollementGateway.getPaperlessSetting('AEPTest').subscribe((data) => {
            this.isAEPTest = data
        })
    }
    onChangeAgentId(): void {
        this.isValidAgent = !this.isValidAgent
        this.hasError = false
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false
        this.ErrorMessages = [] as any[]
    }

    onContinue(): void {
        this.hasError = false
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false
        this.ErrorMessages = [] as any[]

        if (this.enrollment.ISBACK) {
            if (this.enrollment.AGENTNAME !== this.dataEntryStep1.AgentName) {
                this.dataEntryStep1.DateofReceipt = new Date('')
                this.dataEntryStep1.DataSource = ''
                this.selFaxContactType = ''
                this.selEnrollmentMethod = ''
                this.dataEntryStep1.SOA = ''
            }
        }

        if (this._global.currentUser.userProfileName === this.dataEntryStep1.AgentName && sessionStorage.getItem('GoodStandingParams') !== null) {
            this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
            if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                var isAgentGoodStanding: boolean = true
                if (!this.goodStandingValues.CurriculumStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' has not passed training for ' + this._global.selectedPlanYear + '<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this.goodStandingValues.BackgroundCheckStatus) {
                    this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' background check not approved.<br/>')
                    this.hasError = true
                    isAgentGoodStanding = false
                }
                if (!this._global.currentUser.IsDataEntrySpecialist && !this._global.currentUser.IsDataEntryGroupSpecialist) {
                    if (!this.goodStandingValues.LicenseStatus) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' does not have any valid license.<br/>')
                        isAgentGoodStanding = false
                    }
                }
                if (!isAgentGoodStanding) {
                    return
                }
            }
        }
        this.loading = true
        this._enrollementGateway.isValidAgent(this.dataEntryStep1.AgentName).subscribe(
            (validAgentModel) => {
                let isagentvalid = true
                // required only if Good standing check is not required.
                //if (validAgentModel.showEnrollmentSourceMS === true) {
                //    this.showMLPAP = true
                //    this.enrollment.ADMINID = validAgentModel.agentID
                //    this.enrollment.AGENTID = String(validAgentModel.agentID)
                //    this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                //} else if (validAgentModel.showEnrollmentSource === true) {
                //    this.showMLPAP = false
                //    this.enrollment.ADMINID = this._global.currentUser.userProfileId
                //    this.enrollment.AGENTID = String(validAgentModel.agentID)
                //    this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                //}

                if (validAgentModel.errorMessage !== undefined && validAgentModel.errorMessage !== null && validAgentModel.errorMessage.length > 0) {
                    this.ErrorMessages.push(validAgentModel.errorMessage)
                    isagentvalid = false
                } else {
                    if (validAgentModel.agentID === 0) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' Agent not found')
                        isagentvalid = false
                    }
                    if (validAgentModel.IsCallRepUser === true || validAgentModel.isCallCenterAdmin === true) {
                        this.ErrorMessages.push(this.dataEntryStep1.AgentName + ' is not valid for Data Entry enrollment.<br/>')
                        isagentvalid = false
                    }
                    if (validAgentModel.showEnrollmentSourceMS === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        this.showMLPAP = true
                        this.enrollment.ADMINID = validAgentModel.agentID
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                    } else if (validAgentModel.showEnrollmentSource === true) {
                        this.hasError = false
                        this.IsErrorMesssage = false
                        this.EnrollmentMethodError = false
                        this.SOAError = false
                        this.showMLPAP = false
                        this.enrollment.ADMINID = this._global.currentUser.userProfileId
                        this.enrollment.AGENTID = String(validAgentModel.agentID)
                        this.enrollment.INSURANCECOMPID = validAgentModel.insuranceCompId
                    }
                }
                //else {
                //    this.ErrorMessages.push(validAgentModel.errorMessage)
                //    isagentvalid = false
                //}
                this.isValidAgent = isagentvalid
                if (!this.isValidAgent) {
                    this.hasError = true
                    this.focusableEleTop.nativeElement.focus()
                } else {
                    this.hasError = false
                    this.IsErrorMesssage = false
                    this.EnrollmentMethodError = false
                    this.SOAError = false
                    this.CUID = validAgentModel.CUID
                    this.enrollment.AGENTORGID = validAgentModel.AgentOrgId
                    this.enrollment.AGENTDETAILS = validAgentModel.CurrentUser
                    this.AgentID = String(validAgentModel.agentID)
                    if (this.CUID === '9110') {
                        this.enrollment.STEEREDIND = false
                    } else {
                        this.enrollment.STEEREDIND = true
                    }
                }
                this.loading = false
            },
            (err) => {
                this.loading = false
            }
        )
    }

    formSubmit(): void {
        this.hasError = false
        this.isFormValid = true
        this.IsErrorMesssage = false
        this.EnrollmentMethodError = false
        this.SOAError = false

        this.errorMessage = []

        if (this.showMLPAP) {
            this.enrollment.DEX = 'MLPAP'
        } else {
            this.enrollment.DEX = 'AGNTP'
        }
        if (this.showMLPAP) {
            if (this.dataEntryStep1.DataSource === undefined || this.dataEntryStep1.DataSource === '' || this.dataEntryStep1.DataSource === null) {
                //this.ContactTypeInvalid = true
                this.hasError = false
                this.EnrollmentMethodError = false
                this.SOAError = false
                this.errorMessage.push('Contact Type is required')
                this.IsErrorMesssage = true
                this.isFormValid = false
            }
            //else {
            //    this.ContactTypeInvalid = false
            //}
            if (!this.dataEntryStep1.DateofReceipt) {
                //this.dateofReceiptInvalid = true
                this.hasError = false
                this.EnrollmentMethodError = false
                this.IsErrorMesssage = true
                this.errorMessage.push('Date of Receipt cannot be blank')
                this.isFormValid = false
            } else {
                // this.dateofReceiptInvalid = true

                //Test AEP: Make 'AEPTest' key as true while testing AEP

                if (!this.isAEPTest) {
                    let receiptdate = moment(this.dataEntryStep1.DateofReceipt).toDate()

                    if (this.currentDate === undefined && this.currentDate === null) {
                        this.currentDate = new Date()
                    }

                    if (receiptdate > this.currentDate) {
                        this.hasError = false
                        this.EnrollmentMethodError = false
                        this.IsErrorMesssage = true
                        this.errorMessage.push('Date of Receipt can not be future date')
                        this.isFormValid = false
                    }
                }
            }
        } else {
            if (this.dataEntryStep1.DataSource === undefined || this.dataEntryStep1.DataSource === '') {
                this.hasError = false
                this.IsErrorMesssage = false
                this.EnrollmentMethodError = true
                this.isFormValid = false
            } else {
                this.EnrollmentMethodError = false
            }
            if (this.dataEntryStep1.SOA === undefined || this.dataEntryStep1.SOA === '') {
                this.hasError = false
                this.IsErrorMesssage = false
                this.SOAError = true
                this.isFormValid = false
            } else {
                this.SOAError = false
            }
        }

        this.enrollment.AGENTDEX = this.dataEntryStep1.DataSource
        // this.enrollment.DEX = this.dataEntryStep1.DataSource
        this.enrollment.SOA = this.dataEntryStep1.SOA
        this.enrollment.AGENTID = this.AgentID
        this.enrollment.AGENTNAME = this.dataEntryStep1.AgentName
        this.enrollment.USERNAME = this._global.currentUser.userProfileName
        this.enrollment.USERPROFILEID = this._global.currentUser.userProfileId
        //  this.enrollment.INSURANCECOMPID = this._global.currentUser.
        this.enrollment.CUID = this.CUID
        this.enrollment.DATEOFRECEIPT = this.dataEntryStep1.DateofReceipt
        if (this.isFormValid) {
            this._enrollementGateway.setEnrollmentViewModel(this.enrollment)
            this.loading = false
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            this.router.navigate(['/' + insCo + '/enrollment/data-entry/Step2'])
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }

    GetCurrentDate() {
        this._enrollementGateway.getCurrentDate().subscribe((date: Date) => {
            if (date !== undefined && date !== null) this.currentDate = moment(date).toDate()
            else this.currentDate = new Date()
        })
    }

    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
}
